let secondList={

    codapayIdList:['codapay_id_1','codapay_id_220','codapay_id_221','codapay_id_223'],
    codapayPhList:['codapay_ph_250','codapay_ph_251','codapay_ph_252','codapay_ph_253'],
    codapayVnList:['codapay_vn_351']
}

export default secondList


// WEBPACK FOOTER //
// ./js/global/second-config.js